import Vue from "vue"
import App from "./App.vue"
import './registerServiceWorker'
import router from "./router"
import axios from "axios"

import i18n from "@/language"
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)
// vant
import { Cell, CellGroup, Button, Icon, Popup, Toast, Dialog, Field, Loading, Radio, RadioGroup, Swipe, SwipeItem, Tabbar, TabbarItem, Card, Tag } from "vant"

import "@/assets/styles/global.less"
import "@/assets/styles/reset.css"
// 移动端适配
//import "amfe-flexible"

Vue.config.productionTip = false

axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8"
axios.defaults.transformRequest = [function (data) {
  if (
    data &&
    Object.prototype.toString.call(data) === "[object Object]" &&
    !(data instanceof FormData) &&
    !(data instanceof URLSearchParams)
  ) {
    const params = new URLSearchParams()
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        params.append(key, data[key])
      }
    })
    return params.toString()
  }
  return data
}]

Vue.use(Button).use(Cell).use(Icon).use(Popup).use(Toast).use(Dialog).use(Field).use(Loading).use(Radio).use(RadioGroup).use(CellGroup).use(Swipe).use(SwipeItem).use(Tabbar).use(TabbarItem).use(Card).use(Tag)

new Vue({
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#app")
